import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { USER_ROLES } from '../constants';

const useUserRolesDropdown = () => {
  const { t } = useTranslation();

  return useMemo(
    () => [
      {
        label: t('globalAdmin'),
        value: USER_ROLES.GLOBAL_ADMIN,
      },
      {
        label: t('globalUser'),
        value: USER_ROLES.GLOBAL_USER,
      },
    ],
    [t],
  );
};

export default useUserRolesDropdown;
